import React from "react";
import { connect } from "react-redux";
import SummaryHeader from "components/header/SummaryHeader";
import { Package } from "lucide-react";
import AssetManagementTable from "./components/AssetManagementTable";

const AssetManagement = () => {
	return (
	    <div className="space-y-6">
			<SummaryHeader
				title="Asset Management"
				icon={Package}
				description="Manage Company Assets"
				color={"green"}
			/>
			<AssetManagementTable recordId="0" mode="edit"/>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AssetManagement);
